import {FormikErrors} from 'formik';
import {FileUploadFormValues} from './typesV2';
import {FormConfigRecord} from '../../hooks/useDocumentUploaderFormConfigs';
import {DocumentUploadPlanNumberStatus} from '../../schema-types/globalTypes';

type fileUploadValidatorV2PropsType = {
  values: FileUploadFormValues;
  formConfig: FormConfigRecord;
  shouldValidateFirstContact: boolean;
};

export const fileUploadValidatorV2 = (
  props: fileUploadValidatorV2PropsType
): FormikErrors<any> => {
  const {values, formConfig, shouldValidateFirstContact} = props;
  const errors: FormikErrors<FileUploadFormValues> = {};
  // Mandatory fields //////////////////////////////////
  if (!values.documentGroup) {
    errors.documentGroup = 'Please select an option';
    // returning early because we need this variable for currentConfig
    return errors;
  }
  if (!values.datePicker) {
    errors.datePicker = 'Please select a date';
  }
  if (!values.contactId1 && shouldValidateFirstContact) {
    errors.contactName1 = 'Please select a contact';
  }
  if (!values.files?.length) {
    errors.files = 'Please select a file';
  }
  // Optional fields //////////////////////////////////
  const currentConfig = formConfig[values.documentGroup];
  if (
    currentConfig.shouldShowPlanNumber &&
    !values.planNumber &&
    values.planNumberStatus === DocumentUploadPlanNumberStatus.PLAN_NUMBER_NEEDED_KNOWN
  ) {
    errors.planNumber = 'Please select a plan';
  }
  if (currentConfig.shouldShowProvider && !values.providerId) {
    errors.providerId = 'Please select a provider';
  }
  if (currentConfig.shouldShowTaxYear && !values.taxYear) {
    errors.taxYear = 'Please select a tax year';
  }
  return errors;
};
